const SouscriptionCustomerGranteesExtraCompanyInformation = () => null;

export default SouscriptionCustomerGranteesExtraCompanyInformation;
